/**
 * Verification Page Component
 * Main page for managing document verification and trust system
 */

import React from 'react';
import { Helmet } from 'react-helmet-async';
import VerificationDashboard from '../../components/verification/VerificationDashboard';

const VerificationPage: React.FC = () => {
    return (
        <>
            <Helmet>
                <title>Verification Center - SideGO</title>
                <meta
                    name="description"
                    content="Manage your account verification, upload documents, and track your trust score to unlock premium benefits on SideGO."
                />
            </Helmet>

            <div className="container-custom py-8">
                <VerificationDashboard />
            </div>
        </>
    );
};

export default VerificationPage;